'use client';

import { useCountUp } from '@/hooks/useCountUp';

interface CountUpProps {
  end: number;
  suffix?: string;
  duration?: number;
  className?: string;
}

export function CountUp({ end, suffix = '', duration, className }: CountUpProps) {
  const { ref, count } = useCountUp(end, duration);

  return (
    <span ref={ref} className={className}>
      {count}
      {suffix}
    </span>
  );
}
